import React, { Component } from "react";
import SharingDropdown from "../../../../components/SharingDropdown";
import { getCollectionUrl } from "../../../../util";
import { Icon, Dropdown } from "semantic-ui-react";
import "./index.css";

class CollectionHeader extends Component {
  constructor(props) {
    super(props);
    this.openConfirmationDialog = this.openConfirmationDialog.bind(this);
    this.deleteCurrentCollection = this.deleteCurrentCollection.bind(this);

    this.collectionActions = [
      {
        key: `edit`,
        text: "Rename",
        onClick: this.props.actions.openEditCollectionFormModal,
      },
      {
        key: `delete`,
        text: "Delete",
        onClick: this.openConfirmationDialog,
      },
    ];
  }

  openConfirmationDialog() {
    this.props.actions.showConfirmDialog({
      onConfirm: this.deleteCurrentCollection,
      onCancel: this.props.actions.hideConfirmDialog,
      content: `Are you sure you want to delete this collection (${this.props.collection.name})?`,
      confirmText: "Delete",
      confirmColor: "red",
    });
  }

  deleteCurrentCollection() {
    this.props.actions.deleteCollection(this.props.collection._id);
    this.props.actions.hideConfirmDialog();
  }

  render() {
    const collection = this.props.collection;
    const sharingButton = <Icon name="share alternate" size="large" className="sharingbtn" />;
    const gradientColor = {
      from: (collection.gradientColor && collection.gradientColor.from) || "#00a4e8",
      to: (collection.gradientColor && collection.gradientColor.to) || "#61dd9f",
    };
    const gradientStyle = {
      background: `linear-gradient(to right, ${gradientColor.from}, ${gradientColor.to})`,
    };

    return (
      <div className="collectionheader" style={gradientStyle}>
        <span className="name"> {collection.name} </span>
        <div className="actions">
          <SharingDropdown
            trigger={sharingButton}
            url={getCollectionUrl(collection)}
            eventSource="collection"
            campaignName="collection"
            content="Check out this collection on Casemasters #casemasters"
          />
          {this.props.loggedInUser && this.props.loggedInUser.uid === collection.owner.id && (
            <div>
              <Dropdown
                trigger={<Icon name="ellipsis vertical" size="big" className="-ellipsis-nav" />}
                pointing="top right"
                icon={null}
                options={this.collectionActions}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default CollectionHeader;



// WEBPACK FOOTER //
// ./src/scenes/CollectionPage/components/CollectionHeader/index.js